import React, { useState, useEffect, useMemo } from "react";
import sloks from "./sloks.json";

const SlokSearch = () => {
  const [search, setSearch] = useState("");
  const [selectedSlok, setSelectedSlok] = useState(null);

  // Disable page scroll when modal is open
  useEffect(() => {
    document.body.style.overflow = selectedSlok ? "hidden" : "auto";
    return () => (document.body.style.overflow = "auto");
  }, [selectedSlok]);

  // Optimized & safe filtering
  const filteredSloks = useMemo(() => {
    const lower = search.toLowerCase();

    return sloks.filter(({ slok_guj, slok_gujlish, tags, double }) => {
      if (double === 1) return false; // filter once only
      return [slok_guj, slok_gujlish, tags || ""]
        .some((txt) => txt.toLowerCase().includes(lower));
    });
  }, [search]);

  return (
    <div className="container mt-4 slok-search">
      <h2 className="text-center">શ્લોક શોધો</h2>

      {/* Search Input */}
      <input
        type="text"
        className="form-control my-3"
        placeholder="શ્લોક અથવા ટૅગ્સ દ્વારા શોધો..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />

      {/* Results */}
      <div>
        {filteredSloks.length > 0 ? (
          filteredSloks.map((slok) => (
            <div
              key={slok.id}
              className="card p-3 mb-3 shadow-sm"
              onClick={() => setSelectedSlok(slok)}
              style={{ cursor: "pointer" }}
            >
              <p className="fw-bold">
                {slok.slok_no_guj}) {slok.slok_guj}
              </p>
            </div>
          ))
        ) : (
          <p className="text-danger text-center">કોઈ શ્લોક મળ્યો નથી</p>
        )}
      </div>

      {/* Modal */}
      {selectedSlok && (
        <div
          className="modal fade show d-block"
          style={{ background: "rgba(0,0,0,0.5)" }}
          role="dialog"
          aria-modal="true"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">

              <div className="modal-header">
                <h5 className="modal-title">
                  {selectedSlok.slok_no_guj})
                </h5>
                <button className="btn-close" onClick={() => setSelectedSlok(null)}></button>
              </div>

              <div className="modal-body">
                <p className="bg-light p-2 heading">{selectedSlok.slok_guj}</p>
                <hr />

                <p><strong>📖 ગુજરાતી English:</strong></p>
                <p className="bg-light p-2">{selectedSlok.slok_gujlish}</p>

                <p><strong>📖 સંસ્કૃત:</strong></p>
                <pre className="bg-light p-2">{selectedSlok.slok_sanskrit}</pre>

                <p><strong>📖 ગુજરાતી સંસ્કૃત:</strong></p>
                <pre className="bg-light p-2">{selectedSlok.slok_sanskrit_guj}</pre>

                {selectedSlok.tags && (
                  <p><strong>🏷️ ટૅગ્સ:</strong> {selectedSlok.tags}</p>
                )}
              </div>

              <div className="modal-footer">
                <button className="btn btn-danger" onClick={() => setSelectedSlok(null)}>
                  Close
                </button>
              </div>

            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SlokSearch;
